import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';

Vue.use(VueRouter);
console.log(routers);
const router = new VueRouter({
    routes: routers
})


export default router;



// WEBPACK FOOTER //
// ./src/digitalHuman/router/index.js